<template>
  <div id="verified">
    <div
      class="card-dianxin"
      v-if="supplierTypeCode == 1 || supplierTypeCode == 5 || realNameCard > -1"
    >
      <h1>ICCID: {{ verifiedInfo.iccid }}</h1>
      <iframe
        class="dianxin-iframe"
        src="http://iotapp.iot.189.cn:9090/uapp/certifhtml/certif_entry.html?userCode=r/s9Tc00hjiKcR13MIjZHg==&passWord=9u8VuY1xbez6r6k/BBnLlw==&tmstemp="
      ></iframe>
    </div>

    <div class="card-other" v-else>
      <h4>
        尊敬的用户,为了贯彻工信部《电话用户真实身份信息登记规定》,请对您购买的流量卡进行实名认证。
      </h4>
      <div class="main">
        <van-cell-group>
          <van-field
            v-model="verifiedInfo.iccid"
            clearable
            left-icon="info-o"
            placeholder="请输入iccid"
            :disabled="isFirst == 2"
          />
          <van-field
            v-model="verifiedInfo.userPhone"
            maxlength="11"
            clearable
            left-icon="phone-o"
            placeholder="请输入11位手机号码"
            :disabled="isFirst == 2"
          />
          <!--  v-show="qianhairealname" -->
          <van-field
            v-model="verifiedInfo.code"
            clearable
            maxlength="6"
            left-icon="other-pay"
            placeholder="请输入验证码"
            :disabled="isFirst == 2"
          >
            <van-button
              slot="button"
              type="primary"
              size="small"
              :disabled="smsFlag"
              class="codeBtn"
              @click="getSmsCode"
              >获取验证码</van-button
            >
          </van-field>
        </van-cell-group>
        <div class="btnOuter">
          <mt-button
            class="tag-read"
            data-clipboard-action="copy"
            :data-clipboard-text="verifiedInfo.iccid"
            type="primary"
            size="large"
            @click.prevent="sureVerifiedHandler"
            v-if="isFirst == 0"
            >点击复制卡号，去完成实名</mt-button
          >
          <mt-button
            type="primary"
            size="large"
            @click.prevent="payRealName"
            v-if="isFirst == 2"
            >支付实名费用</mt-button
          >
        </div>
        <p style="color:red;padding-top:20px;">温馨提示 </p> 
        <p>  1：以'145','146','166','177','199'号段开头的号码无法接收短信验证码</p>
        <p>2：请完成验证码后复制iccid号至运营商实名认证处粘贴iccid号</p>
        <div
          style="color: red; padding-top: 20px; line-height: 24px"
          v-if="isFirst != 2"
        >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard';
import { wxRequest, verified } from "@/api/user";
import { Dialog } from "vant";
export default {
  data() {
    return {
      qianhairealname:false,
      state: "",
      supplierTypeCode: "",
      verifiedInfo: {
        iccid: '',
        name: "张三",
        userPhone: "",
        idcard: "41152819960319589X",
        code:null
      },
      disabledFlag: false,
      existFrontImg: false,
      existBackImg: false,
      existHandImg: false,
      frontImgUrl: "",
      backImgUrl: "",
      handImgUrl: "",
      realNameCard: -1, //需弹实名的卡
      isFirst: 0,
    };
  },
  methods: {
       getSmsCode(){
            var data = {
                userPhone: this.verifiedInfo.userPhone
            }
            wxRequest("wxAuth/qianhai/auth/code", data, "post").then(res => {
                if(res.data.code == 200){
                    var n = 60;
                    this.btnTxt = '重新发送' + n +'s';
                    let timer = window.setInterval(() => {   
                        n--;                     
                        this.btnTxt = '重新发送' + n +'s';
                        if(n < 1){
                            window.clearInterval(timer);
                            this.btnTxt = '发送验证码';
                        }
                    },1000)
                    Dialog.alert({title: "提示", message:"发送成功"});
                }else{
                    Dialog.alert({title: "提示", message:res.data.message});
                }
            })
        },
    getVerifiedInfoHandler() {
      var data = {
        iccid: localStorage.getItem("iccid"),
      };
      // wxRequest("wxAuth/list", data, "post").then(res => {  //查照片的接口
      //     if(res.data.code == 200 && res.data.data){
      //         for(var key in this.verifiedInfo){
      //             this.verifiedInfo[key] = res.data.data[key];
      //             this.existFrontImg = true;
      //             this.existBackImg = true;
      //             this.existHandImg = true;
      //             this.frontImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.headerUrl
      //             this.backImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.backHeaderUrl
      //             this.handImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.handheldUrls
      //         }
      //     }
      // })
      wxRequest("bindPhone/phone/info/iccid", data, "post").then((res) => {
        if (res.data.code == 200 && res.data.data) {
          for (var key in this.verifiedInfo) {
            this.verifiedInfo[key] = res.data.data[key];
          }
        }
      });
    },
    sureVerifiedHandler() {
       var clipboard = new Clipboard('.tag-read')
        clipboard.on('success', e => {
                  console.log('复制成功')
                  clipboard.destroy()// 释放内存
             })
      this.verifiedInfo.name='张三';
      this.verifiedInfo.idcard='41152819960319589X'
      wxRequest("bindPhone/phone", this.verifiedInfo, "post").then((res) => {
        if (res.data.code == 200) {
             window.location.href='http://auth.yeepn.com/auth10646.html'
        } else {
          this.$messagebox.alert(res.data.message);
        }
      });
    },
    //支付实名
    payRealName() {
      let fd = new FormData();
      fd.append("iccid", this.verifiedInfo.iccid);
      let _this = this;
      wxRequest("order/bind/phone", fd, "post").then((res) => {
        let param = res.data.data.param;
        WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            _this.$router.push({
              path: "/user/home",
            });
          }
        });
      });
    },
  },
  created() {
    this.qianhairealname=localStorage.getItem('qianhairealname')
    this.verifiedInfo.iccid= this.$route.query.iccid;
    var state = this.$route.query.state;
    this.state = state;
    if (state == 1 || state == 3) {
      this.disabledFlag = true;
    }
    this.getVerifiedInfoHandler();
  },

  mounted() {
    this.qianhairealname=localStorage.getItem('qianhairealname')
    this.supplierTypeCode = this.$route.query.supplierTypeCode;
    this.verifiedInfo.iccid = this.$route.query.iccid
      ? this.$route.query.iccid
      : localStorage.getItem("iccid");
    this.realNameCard = this.$route.query.realNameCard;
    if (
      this.supplierTypeCode != 1 &&
      this.supplierTypeCode != 5 &&
      this.realNameCard == -1
    ) {
      wxRequest(
        "bindPhone/state",
        { iccid: this.verifiedInfo.iccid },
        "post"
      ).then((res) => {
        if (res.data.code == 200) {
          let result = res.data.data;
          if (result.bindState == 2) {
            this.isFirst = result.isFirst;
          } else {
            this.disabledFlag = true;
          }
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    }
    if (this.isFirst == 2) {
      Dialog({
        message:
          "尊敬的用户，您当前有未支付的实名失败订单，请你优化支付完订单信息，再重新登录实名认证。",
      });
    }
  },
};
</script>
<style lang="less">
#verified {
  height: 100%;
  h4 {
    color: #fff;
    font-size: 10px;
    background: #26a2ff;
    line-height: 1.5em;
    padding: 6px 3%;
  }
  ul {
        margin: 10px;
        li {
            line-height: 36px;
            padding: 3px 0;
            border-bottom: 1px solid #ffa33a;
            svg {
                vertical-align: middle;
                margin-right: 8px;
            }
            .codeBtn {
                float: right;
                margin-top: 2px;
            }
        }
    }
  .main {
    height: calc(100% - 48px);
    padding: 0 4%;
    form {
      height: 100%;
    }
    .line {
      border-bottom: 1px solid #e5e5e5;
    }
    // .many {
    //     display: flex;
    //     justify-content: space-between;
    //     label {
    //         display: block;
    //         line-height: 36px;
    //     }
    //     .uploadOuter {
    //         position: relative;
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;
    //         width: 48%;
    //         height: 100px;
    //         border: 1px dashed #e5e5e5;
    //         box-sizing: border-box;
    //         input[type=file] {
    //             position: absolute;
    //             top: 0;
    //             width: 0;
    //             width: 100%;
    //             height: 100%;
    //             opacity: 0;
    //         }
    //         img {
    //             width: 100%;
    //             height: 100%;
    //         }
    //     }
    // }
    // .title {
    //     line-height: 28px;
    //     margin-top: 10px;
    // }
    .btnOuter {
      // display: flex;
      // align-items: center;
      // height: calc(100% - 424px;)

      margin-top: 30px;
    }
  }

  .card-dianxin {
    width: 100%;
    height: 100%;
    h1 {
      font-size: 14px;
      background: #fff;
      line-height: 1.5em;
      padding: 6px 3%;
    }
    .dianxin-iframe {
      width: 100%;
      height: 100%;
    }
  }

  .card-other {
    width: 100%;
    height: 100%;
  }
  input.van-field__control {
    padding-left: 5px;
    line-height: 24px;
  }
}
</style>
